import { ArticleModel } from './../archive/article.model';
import { NoteModel } from './note.model';
export class NoteDetailModel {
  noteDetailId: number = 0;
  noteId: number = 0;
  note: NoteModel = new NoteModel();
  conceptInvoicingId: number | null = null;
  articleId: number | null = null;
  article: ArticleModel = new ArticleModel();
  storeId: number | null = null;
  totalTime: number = 1;
  quantity: number = 0;
  unitValue: number = 0; //Backend
  ivaRate: number = 0; //Backend
  totalValue: number = 0;  //Backend
  document: string | null = null;
  invoicedValueConcept: number = 0;
  residueValueConcept: number = 0;
  accountingCostCenter: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
